/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What scale does this use?`)
};

const es_gpa_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué escala se usa aquí?`)
};

const de_gpa_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Skala wird verwendet?`)
};

const nl_gpa_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke schaal wordt hier gebruikt?`)
};

const fr_gpa_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle échelle est utilisée ici ?`)
};

const it_gpa_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale scala viene usata?`)
};

const pt_br2_gpa_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual escala é usada aqui?`)
};

const pt_gpa_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que escala é usada?`)
};

const ja_gpa_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのスケールが使われていますか?`)
};

const zh_gpa_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用的是哪种评分制度？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_faq_q2", locale)
	if (locale === "en") return en_gpa_faq_q2(inputs)
	if (locale === "es") return es_gpa_faq_q2(inputs)
	if (locale === "de") return de_gpa_faq_q2(inputs)
	if (locale === "nl") return nl_gpa_faq_q2(inputs)
	if (locale === "fr") return fr_gpa_faq_q2(inputs)
	if (locale === "it") return it_gpa_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_faq_q2(inputs)
	if (locale === "pt") return pt_gpa_faq_q2(inputs)
	if (locale === "ja") return ja_gpa_faq_q2(inputs)
	return zh_gpa_faq_q2(inputs)
};